import React, { createContext, useContext, useState } from 'react';
import { GeneratedInvoice } from './alcanzaData';

// Cross-page demo state: invoices "saved" on the Generate page appear on the
// Invoice list/detail pages (they aren't persisted to the API — the canned
// flow). localStatus tracks status changes for those saved invoices.
type DemoCtx = {
  saved: GeneratedInvoice[];
  addInvoice: (inv: GeneratedInvoice) => void;
  localStatus: Record<string, string>;
  setLocalStatus: (invoiceNumber: string, status: string) => void;
};

const Ctx = createContext<DemoCtx>({
  saved: [],
  addInvoice: () => {},
  localStatus: {},
  setLocalStatus: () => {},
});

export const useDemo = () => useContext(Ctx);

export const DemoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [saved, setSaved] = useState<GeneratedInvoice[]>([]);
  const [localStatus, setLocalStatusState] = useState<Record<string, string>>({});
  const addInvoice = (inv: GeneratedInvoice) => setSaved((prev) => [inv, ...prev]);
  const setLocalStatus = (invoiceNumber: string, status: string) =>
    setLocalStatusState((prev) => ({ ...prev, [invoiceNumber]: status }));
  return (
    <Ctx.Provider value={{ saved, addInvoice, localStatus, setLocalStatus }}>{children}</Ctx.Provider>
  );
};
